export default "__VITE_ASSET__C1SL8jtw__"